import { doc, getDoc } from "firebase/firestore";
import { getFirebaseFirestore } from "@/config/firebase";
import { isDemoMode } from "@/demo/demoMode";
import * as demoStore from "@/demo/demoStore";
import type { BranchPolicy } from "@vlab-corporation/vlab-pilates-service-interface/branch";

const DEFAULT_BRANCH_POLICY: BranchPolicy = {
  membershipPricing: [],
  instructorPayScale: [],
  journalFormat: { enabled: false },
};

export async function getBranchPolicy(ownerUid: string, centerId: number): Promise<BranchPolicy> {
  if (isDemoMode()) return demoStore.getBranchPolicy(centerId);
  const ref = doc(
    getFirebaseFirestore(),
    "users",
    ownerUid,
    "centers",
    String(centerId),
    "branchPolicy",
    "default",
  );
  const snap = await getDoc(ref);
  if (!snap.exists()) {
    return { ...DEFAULT_BRANCH_POLICY };
  }
  return snap.data() as BranchPolicy;
}
